export const PROCESS = {
  roofing: [
    { title: "Free Roof Inspection", desc: "We get up top and assess decking, flashing, and shingles — honestly." },
    { title: "Clear Written Quote", desc: "You get an itemized price and a straight repair-vs-replace call." },
    { title: "Tear-Off & Install", desc: "We protect your property, replace what's needed, and keep it clean." },
    { title: "Final Walkthrough", desc: "We check every detail with you before we call it done." },
  ],
  siding: [
    { title: "On-Site Assessment", desc: "We check panels, seams, and what's hiding behind them." },
    { title: "Material & Price Plan", desc: "You pick a look that fits your home and budget, priced upfront." },
    { title: "Careful Installation", desc: "We seal it right, protect landscaping, and stay on schedule." },
    { title: "Final Walkthrough", desc: "We review the finish with you, corner to corner." },
  ],
  gutters: [
    { title: "Water-Flow Assessment", desc: "We see how water really moves off your roof." },
    { title: "Sizing & Quote", desc: "Properly sized gutters and downspouts, priced clearly." },
    { title: "Clean Installation", desc: "Installed, sealed, and routed away from your foundation." },
    { title: "Function Check", desc: "We confirm it flows right before we leave." },
  ],
  "kitchen-remodeling": [
    { title: "Design Walkthrough", desc: "We plan around how you actually cook and gather." },
    { title: "Detailed Quote", desc: "Cabinets, counters, and finishes itemized upfront." },
    { title: "On-Schedule Build", desc: "Tidy daily, with any issues flagged before we act." },
    { title: "Final Reveal", desc: "We walk your new kitchen together and perfect the details." },
  ],
  "bathroom-remodeling": [
    { title: "Space & Needs Review", desc: "We look at layout, plumbing, and hidden moisture." },
    { title: "Clear Quote", desc: "Tile, fixtures, and finishes priced with no guessing." },
    { title: "Efficient Build", desc: "We minimize downtime and keep the site clean." },
    { title: "Final Walkthrough", desc: "We check every seal and finish with you." },
  ],
  "basement-finishing": [
    { title: "Moisture & Layout Check", desc: "We confirm it's ready and plan the space." },
    { title: "Itemized Quote", desc: "Framing, electrical, flooring, and finishes upfront." },
    { title: "Full Build", desc: "Permitted, on schedule, and treated like your home." },
    { title: "Final Walkthrough", desc: "We hand over a space that's ready to live in." },
  ],
  "general-maintenance": [
    { title: "Facility Walkthrough", desc: "We assess repairs and priorities across your space." },
    { title: "Straightforward Pricing", desc: "Clear costs, and what needs attention now vs later." },
    { title: "Scheduled Work", desc: "Done around your hours, with approvals before extra work." },
    { title: "Sign-Off", desc: "We confirm everything's back in service." },
  ],
  "restaurant-build-outs": [
    { title: "Scope & Timeline", desc: "We map the build to your opening date and menu." },
    { title: "Itemized Quote", desc: "Kitchen, dining, and code work priced clearly." },
    { title: "Coordinated Build", desc: "We keep it moving and inspection-ready." },
    { title: "Opening-Ready Handoff", desc: "We walk the finished space before you open." },
  ],
  "retail-storefronts": [
    { title: "Space & Landlord Review", desc: "We work within center and lease requirements." },
    { title: "Clear Quote", desc: "Layout, fixtures, and storefront priced upfront." },
    { title: "On-Schedule Build", desc: "Approvals and inspections kept on track." },
    { title: "Grand-Opening Handoff", desc: "We hand over a space ready for foot traffic." },
  ],
};

export const EXTRA_FAQS = {
  roofing: [
    { q: "Do you offer any warranty on a new roof?", a: "Yes — you get manufacturer material warranties plus our workmanship guarantee, all in writing." },
    { q: "Can you work around bad weather?", a: "We watch the forecast and schedule tear-off so your home is never left open to a storm." },
  ],
  siding: [
    { q: "What siding materials do you install?", a: "A range of quality vinyl and fiber options — we recommend what fits your home and budget, not the priciest choice." },
    { q: "Can you match my existing siding for a repair?", a: "In most cases yes; if an exact match isn't available, we'll show you the closest option before doing the work." },
  ],
  gutters: [
    { q: "What size gutters do I need?", a: "It depends on your roof area and pitch — we size them to handle a heavy New Jersey storm." },
    { q: "Do you offer seamless gutters and guards?", a: "Yes. Seamless gutters mean fewer leaks, and we'll tell you if guards are worth it for your roof." },
  ],
  "kitchen-remodeling": [
    { q: "Can you help me pick appliances and finishes?", a: "Absolutely — we build around what you have or help you choose pieces that fit the layout and budget." },
    { q: "Do you handle the plumbing and electrical too?", a: "Yes, we coordinate the licensed trades so your project is done to code, start to finish." },
  ],
  "bathroom-remodeling": [
    { q: "Can you make a small bathroom feel bigger?", a: "Often yes — smart layout, lighting, and the right tile can completely change how a small bathroom feels." },
    { q: "Do you install walk-in or accessible showers?", a: "Yes, we build walk-in and low-threshold showers designed around your needs." },
  ],
  "basement-finishing": [
    { q: "Can you add a bathroom or bedroom down there?", a: "Yes, as long as we meet egress and code — we'll tell you exactly what's possible during the walkthrough." },
    { q: "Will finishing add heat and lighting?", a: "Yes, we plan insulation, lighting, and heat so the space is comfortable year-round." },
  ],
  "general-maintenance": [
    { q: "Do you offer scheduled recurring maintenance?", a: "Yes, we can set up regular visits or be on-call for your facility — whatever keeps you running." },
    { q: "How fast can you respond to an urgent repair?", a: "We prioritize urgent issues and give you a realistic response time the moment you call." },
  ],
  "restaurant-build-outs": [
    { q: "Can you build a commercial kitchen to health code?", a: "Yes — we build back-of-house to code and coordinate the trades so inspections go smoothly." },
    { q: "Can you phase work so we stay partially open?", a: "Often yes; we'll phase the build where possible to limit downtime and lost revenue." },
  ],
  "retail-storefronts": [
    { q: "Do you build displays and fixtures?", a: "Yes — from shelving and displays to lighting and finishes that fit your brand." },
    { q: "Can you handle storefront glass and signage?", a: "We coordinate storefront work and signage support as part of the build." },
  ],
};
